/**
 * Route for a submission folder. Archived folders live under their own URL segment,
 * the same way archived collections do, so the address bar says what you are looking at.
 */
export const submissionFolderPath = (folder) => {
  const folderID =
    folder?.submissionFolderID_ids ?? folder?.submissionFolderID ?? folder;
  return folder?.isArchived_ysn
    ? `/collections/submissions/archive/${folderID}`
    : `/collections/submissions/${folderID}`;
};

/** True when the current path is the archived variant of a submission folder route. */
export const isArchivedFolderPath = (pathname = "") =>
  pathname.includes("/collections/submissions/archive/");
